import { wikiLangCodes } from 'lib/lang';
import { capitalizeString } from 'shared-helpers/common';

import type { Course } from 'shared-types';

interface Params {
  course?: Pick<Course, 'language' | 'languageVersions'>;
  languageKeys?: Course['language'][];
  onlyPublished?: boolean;
}

/**
 * Returns an object mapping language codes to their capitalized names and labels.
 * Object is returned instead of an array for faster O(1) lookup
 */
const getCourseLanguageVersionOptions = ({
  course,
  languageKeys,
  onlyPublished = false
}: Params) => {
  const options: Record<
    string,
    {
      capitalizedName: string;
      isPublished: boolean;
      label: string;
    }
  > = {};

  const languageVersions =
    course?.languageVersions || ({} as typeof course.languageVersions);

  let allLanguages = [];
  if (course) {
    allLanguages = [course.language, ...Object.keys(languageVersions)];
  } else if (languageKeys) {
    allLanguages = languageKeys;
  }

  allLanguages.forEach((lang) => {
    const languageObject = wikiLangCodes.find((l) => l.value === lang);

    const label = languageObject?.label || lang;

    const isPublished =
      course && lang === course.language
        ? true
        : languageVersions[lang]?.isPublished || false;
    if (onlyPublished && !isPublished) return;

    options[lang] = {
      capitalizedName: capitalizeString(label),
      isPublished,
      label
    };
  });

  return options;
};

export default getCourseLanguageVersionOptions;
